import { NON_DASHBOARD_PAGES } from "enums";
import { useLocation } from "react-router-dom";
import { ReactComponent as BellIcon } from "assets/svgs/bell.svg";
import { ReactComponent as SearchIcon } from "assets/svgs/search.svg";

const NotificationBar = () => {
  const location = useLocation();

  const hideMenu = NON_DASHBOARD_PAGES.includes(location.pathname);
  const paymentStatusPage = ["/payment"].includes(location.pathname);

  if (hideMenu || paymentStatusPage) return <></>;

  return (
    <div className="hidden lg:pr-0 lg:flex lg:justify-end">
      <div className="top-bar flex justify-between items-center p-4 pb-0 gap-[60px]">
        <div className="search-bar flex items-center cursor-pointer opacity-0 select-none">
          <SearchIcon />
        </div>

        <div className="notifications-bar flex items-center justify-center cursor-pointer opacity-0 select-none">
          <BellIcon />
        </div>

      </div>
    </div>
  );
};

export default NotificationBar;
